import {VideoReviewsMeta} from '@/src/(pages)/video/meta'

export {VideoReviewsMeta}
